import { useEffect } from "react";

/**
 * Observes `.jst-reveal` nodes and toggles `.jst-reveal--visible` when in view.
 * Pass `pathname` (or any token) in deps to re-scan after client-side navigation.
 */
export function useJstReveal(deps = []) {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) {
      document
        .querySelectorAll(".jst-reveal")
        .forEach((el) => el.classList.add("jst-reveal--visible"));
      return undefined;
    }
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("jst-reveal--visible");
            obs.unobserve(e.target);
          }
        });
      },
      { rootMargin: "0px 0px -6% 0px", threshold: 0.06 }
    );
    const scan = () => {
      document.querySelectorAll(".jst-reveal:not(.jst-reveal--visible)").forEach((el) => {
        obs.observe(el);
      });
    };
    scan();
    const t1 = window.setTimeout(scan, 400);
    const t2 = window.setTimeout(scan, 1200);
    return () => {
      window.clearTimeout(t1);
      window.clearTimeout(t2);
      obs.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
